var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "show-modal": _vm.showModal,
      "primary-footer-button-translation": _vm.$t("pages.payroll.download"),
      centered: true,
      showPrimaryFooterButton: false,
      showSecondaryFooterButton: false,
    },
    on: _vm._d({}, [
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("info-component", {
              attrs: { message: _vm.message, type: _vm.modalType },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }